import {
  Box,
  Card,
  CardContent,
  Grid,
  Link,
  Theme,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";

import UploadFormatImg from "assets/images/upload_target_excel.svg";

const useStyles = makeStyles((theme: Theme) => ({
  content: {
    "& ul": {
      margin: 0,
      paddingLeft: 26,
      listStyleType: "disc",
      "& > li": { ...theme.typography.body1 },
    },
  },
  title: {
    letterSpacing: 0.25,
  },
  formatImage: {
    position: "relative",
    overflow: "hidden",
    margin: 0,
    height: 140,
    "& > img": {
      position: "absolute",
      left: 0,
      top: 0,
    },
  },
}));

const Requirements = () => {
  const classes = useStyles();

  return (
    <Card>
      <CardContent>
        <Grid
          container
          direction="column"
          spacing={2}
          className={classes.content}
        >
          <Grid item>
            <Typography variant="h2" className={classes.title}>
              Requirements
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" component="p">
              When uploading targets to view matches, please remember to select
              workflow and disease type.
            </Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" component="h3">
              Format the document like the image below:
            </Typography>
          </Grid>
          <Grid item>
            <figure className={classes.formatImage}>
              <img src={UploadFormatImg} alt="Upload Format" />
              <Typography component="figcaption" className="sr-only">
                Abbreviated example of a table with two columns and four rows.
                Only the first column has entries. First column's header is
                "Target Name". Example column entries are gene symbols such as
                "BRCA1, BRCA2, PALB2" etc.
              </Typography>
            </figure>
          </Grid>
          <Grid item>
            <Typography variant="body1" component="h3">
              Your file can include:
            </Typography>
            <ul>
              <li>HGNC symbols or gene-fusions</li>
              <li>Only one target per line/row</li>
            </ul>
          </Grid>
          <Grid item>
            <Box py={1}>
              <Typography variant="body1" component="h3">
                Please see examples below for acceptable target formats:
              </Typography>
            </Box>
          </Grid>
          <Grid item>
            <ul>
              <li>
                HGNC gene symbols:{" "}
                <Link color="secondary" underline="hover">
                  BRCA1
                </Link>
              </li>
              <li>
                HGNC fusion symbols:{" "}
                <Link color="secondary" underline="hover">
                  EML4/ALK
                </Link>
              </li>
            </ul>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Requirements;
